// Pic-Loud and Pic-Loud Share (share.pic-loud.com) are the same build; the host decides which app renders.
// Locally, run the share app with: PORT=3001 REACT_APP_FORCE_SHARE=true npm start

export const MAIN_URL = (process.env.REACT_APP_BASE_URL || "https://pic-loud.com").replace(/\/$/, "");
export const SHARE_URL = (process.env.REACT_APP_SHARE_URL || "https://share.pic-loud.com").replace(/\/$/, "");

export const isShareHost =
  window.location.hostname.startsWith("share.") || process.env.REACT_APP_FORCE_SHARE === "true";
